import store from '@/stores/'
import UNIQUE from '@/common/unique'

const defaultValue = 'BUTTON'
const langValue = function () {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = defaultValue
  })
  return obj
}

export default {
  id: 'button',
  name: 'button2',
  type: 'action', // 좌측 리스트 구분
  moduleName: 'editor_module_button2',
  dataSet: {
    mods: 'button',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'button',
        value: langValue(),
        detail: {
          options: ['button', 'background', 'border', 'text', 'radius']
        }
      },
      {
        columnId: UNIQUE.mid(),
        type: 'button',
        value: langValue(),
        detail: {
          options: ['button', 'background', 'border', 'text', 'radius']
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'flex',
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
